import React from 'react'
import { FeaturedLayout } from '../../layouts'
import PromocionesTab from './PromocionesTab'
import { useTemporadaActiva } from './useTemporadaActiva'
import TemporadaSelector from './TemporadaSelector'

const PagosPromociones = () => {
  const { temporadaId, temporadas, setTemporadaId } = useTemporadaActiva()

  return (
    <FeaturedLayout
      title="Promociones y descuentos"
      subtitle="Configura descuentos por hermanos, becas y cortesias"
    >
      <PromocionesTab
        temporadaId={temporadaId}
        temporadaSelector={<TemporadaSelector temporadas={temporadas} value={temporadaId} onChange={setTemporadaId} />}
      />
    </FeaturedLayout>
  )
}

export default PagosPromociones
